import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { computed, ref, watch } from 'vue'
import isNil from 'lodash/isNil'

import { centsToDollars, dollarsToCents } from '@/helpers/strings'
import EditableTableColumn from './EditableTableColumn.vue'

interface Props {
  sourceValue: number | null
  loading?: boolean
  success?: boolean
  editable?: boolean
  min?: number
  max?: number
  step?: number
  precision?: number
  isPricingInput?: boolean
  settingKey?: string
}

interface Emits {
  (e: 'save', value: number): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EditableInputNumber',
  props: {
    sourceValue: {},
    loading: { type: Boolean, default: false },
    success: { type: Boolean, default: false },
    editable: { type: Boolean, default: true },
    min: { default: 0 },
    max: {},
    step: { default: 1 },
    precision: { default: 0 },
    isPricingInput: { type: Boolean, default: false },
    settingKey: { default: '' }
  },
  emits: ["save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const isEditingMode = ref(false)

const isActuallyPricing = computed(() => {
  return (
    props.isPricingInput && props.settingKey !== 'ev_trip_extend_hour_limit'
  )
})

const getInitialValue = () => {
  if (isNil(props.sourceValue)) return 0

  return isActuallyPricing.value
    ? centsToDollars(props.sourceValue)
    : Number(props.sourceValue)
}

const value = ref<number>(getInitialValue())

watch(
  () => props.success,
  (newValue, prevValue) => {
    // changed from `false` to `true` means that updating action was success
    if (!prevValue && newValue) isEditingMode.value = false
  }
)

const formattedSoureValue = computed(() => {
  if (isNil(props.sourceValue) || !isActuallyPricing.value) {
    return props.sourceValue
  }

  return centsToDollars(props.sourceValue)
})

const handleEditPress = () => {
  isEditingMode.value = true
}

const handleSavePress = () => {
  emit(
    'save',
    isActuallyPricing.value ? dollarsToCents(value.value) : value.value
  )
}

const handleCancelPress = () => {
  isEditingMode.value = false
  value.value = getInitialValue()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(EditableTableColumn, {
      editable: _ctx.editable,
      sourceValue: formattedSoureValue.value,
      saveLoading: _ctx.loading,
      isEditingMode: isEditingMode.value,
      onSaveClick: handleSavePress,
      onCancelClick: handleCancelPress,
      onEditClick: handleEditPress
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input_number, {
          modelValue: value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
          step: _ctx.step,
          min: _ctx.min,
          max: _ctx.max,
          precision: _ctx.precision,
          size: "small"
        }, null, 8, ["modelValue", "step", "min", "max", "precision"])
      ]),
      _: 1
    }, 8, ["editable", "sourceValue", "saveLoading", "isEditingMode"])
  ]))
}
}

})